import { generatePath } from "react-router-dom";
import { Module, PATH_USER } from "@/constants";
import { useModulePermissions } from "@/modules/account/hooks/useModulePermissions";
import {
  EntityListLink,
  EntityListLinkProps,
} from "@/components/EntityListLink";

interface UserListLinkProps extends Omit<EntityListLinkProps, "path"> {
  userId: string;
}

export const UserListLink = ({
  userId,
  label,
  target,
  className,
}: UserListLinkProps) => {
  const usersPermissions = useModulePermissions(Module.Users);

  if (!userId || !usersPermissions.can_read) {
    return null;
  }

  return (
    <EntityListLink
      path={generatePath(PATH_USER, { userId })}
      label={label}
      target={target}
      className={className}
    />
  );
};
